import { render, staticRenderFns } from "./UploadLoader.vue?vue&type=template&id=0583816f&scoped=true&"
import script from "./UploadLoader.vue?vue&type=script&lang=js&"
export * from "./UploadLoader.vue?vue&type=script&lang=js&"
import style0 from "./UploadLoader.vue?vue&type=style&index=0&id=0583816f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0583816f",
  null
  
)

export default component.exports